import React, { ReactNode, useState } from "react";
import classNames from "classnames";
import CloseSVG from "./icons/close.svg";
import FlashSVG from "./icons/flash.svg";
import DangeSVG from "./icons/danger.svg";

type BannerVariant = "purple" | "warning";

export type BannerProps = {
  variant?: BannerVariant;
  title: string;
  hideCloseBtn?: boolean;
  children: ReactNode;
};

const variantStyles: Record<
  BannerVariant,
  { border: string; bg: string; Icon: React.ComponentType }
> = {
  purple: {
    border: "border-[#81109C]",
    bg: "bg-[#81109C08]",
    Icon: FlashSVG,
  },
  warning: {
    border: "border-[#CACACA]",
    bg: "bg-[#F9F9F9]",
    Icon: DangeSVG,
  },
};

export const Banner = ({
  variant = "purple",
  title,
  hideCloseBtn,
  children,
}: BannerProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => setIsOpen(false);

  if (!isOpen) return null;

  const { border, bg, Icon } = variantStyles[variant];

  return (
    <div
      className={classNames(
        "rounded-[12px] p-6 text-sm grid grid-cols-[24px_1fr_24px] gap-4 border",
        border,
        bg
      )}
    >
      <Icon />
      <div>
        <p className="font-bold mb-0">{title}</p>
        <div className="mb-0">{children}</div>
      </div>
      {!hideCloseBtn && (
        <div className="cursor-pointer" onClick={handleClose}>
          <CloseSVG />
        </div>
      )}
    </div>
  );
};
